// widget/src/next-dynamic-shim.tsx
// Drop-in replacement for `next/dynamic` inside the widget bundle.
// SearchWidget.tsx uses `next/dynamic` to lazy-load AgentChatWidget; in the
// embedded widget bundle we don't have Next.js, so we rewire that import to
// this file via a Vite alias and use React.lazy + Suspense instead.

import { lazy, Suspense, type ComponentType, type ReactElement } from 'react';

interface DynamicOptions {
  ssr?: boolean;
  loading?: () => ReactElement | null;
}

export default function dynamic<P extends object>(
  loader: () => Promise<{ default: ComponentType<P> }>,
  options?: DynamicOptions,
): ComponentType<P> {
  const LazyComponent = lazy(loader);
  const Fallback = options?.loading ?? (() => null);

  return function DynamicallyLoaded(props: P) {
    return (
      <Suspense fallback={<Fallback />}>
        <LazyComponent {...props} />
      </Suspense>
    );
  };
}
